var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.list),function(row,index){return _c('tr',{key:index},_vm._l((_vm.columnConfig),function(column,idx){return _c('td',{key:idx,staticClass:"has-text-centered"},[_c('table-cell',{attrs:{"column":column,"item":row}})],1)}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851b717c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listing/TableBody.vue
// module id = null
// module chunks = 